import { render, staticRenderFns } from "./DiseaseTable.vue?vue&type=template&id=1bca5a6f&scoped=true&"
import script from "./DiseaseTable.vue?vue&type=script&lang=ts&"
export * from "./DiseaseTable.vue?vue&type=script&lang=ts&"
import style0 from "./DiseaseTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DiseaseTable.vue?vue&type=style&index=1&id=1bca5a6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bca5a6f",
  null
  
)

export default component.exports